import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetTenantDetailQuery = (tenantId: number) => {
  const { getTenantDetail } = useServicesContext();

  return useQuery({
    queryKey: ['GET_TENANT_DETAIL', tenantId],
    queryFn: () => getTenantDetail(tenantId),
    enabled: Boolean(tenantId),
  });
};
